import React from "react";
import { NavLink } from "react-router-dom";
import styles from "./GoHighLevelNav.module.css";

const NAV_ITEMS = [
  { to: "/sysadmin/gohighlevel/dashboard", label: "Dashboard" },
  { to: "/sysadmin/gohighlevel/agencies", label: "Agencies" },
  { to: "/sysadmin/gohighlevel/locations", label: "All Locations" },
];

const GoHighLevelNav: React.FC = () => (
  <div className={styles.navContainer}>
    <div className={styles.navHeader}>GoHighLevel</div>
    <nav className={styles.nav}>
      {NAV_ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) =>
            `${styles.navLink} ${isActive ? styles.active : ""}`
          }
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  </div>
);

export default GoHighLevelNav;
